/**
 * geometry.js — small shared helpers for the SCOPE drawing path.
 */

/** Shoelace formula — polygon area in the raw unit the points are in (pixels). */
export function polygonAreaPx(points) {
  if (!points || points.length < 3) return 0;
  let sum = 0;
  for (let i = 0; i < points.length; i++) {
    const [x1, y1] = points[i];
    const [x2, y2] = points[(i + 1) % points.length];
    sum += x1 * y2 - x2 * y1;
  }
  return Math.abs(sum / 2);
}

export function polygonPerimeterPx(points) {
  if (!points || points.length < 2) return 0;
  let total = 0;
  for (let i = 0; i < points.length; i++) {
    const [x1, y1] = points[i];
    const [x2, y2] = points[(i + 1) % points.length];
    total += Math.hypot(x2 - x1, y2 - y1);
  }
  return total;
}

export function dist([x1, y1], [x2, y2]) {
  return Math.hypot(x2 - x1, y2 - y1);
}

/** Convert pixel area to square metres using a calibrated scale factor (metres per pixel). */
export function pxAreaToM2(areaPx, scaleFactor) {
  if (!scaleFactor || scaleFactor <= 0) return 0;
  return +(areaPx * scaleFactor * scaleFactor).toFixed(2);
}

/** Convert pixel length to metres using the calibrated scale factor. */
export function pxLenToM(lenPx, scaleFactor) {
  if (!scaleFactor || scaleFactor <= 0) return 0;
  return +(lenPx * scaleFactor).toFixed(2);
}

/** Flatten `[[x,y],[x,y],...]` → `[x,y,x,y,...]` for Konva Line `points` prop. */
export function flattenPoints(points) {
  if (!points) return [];
  const out = [];
  for (const [x, y] of points) out.push(x, y);
  return out;
}
